import React from "react";
import { IconButton, Radio, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography, withStyles } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import GetAppIcon from '@material-ui/icons/GetApp';
import { APP_STUDIES } from "../../../_constants";
import AssessmentIcon from '@material-ui/icons/Assessment';
import VideocamIcon from '@material-ui/icons/Videocam';
import { formatDateTime } from "../../../_helpers"

import AddCommentIcon from '@material-ui/icons/AddComment';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import CommentIcon from '@material-ui/icons/Comment';
import { FormValidatorField, StudyDto, StudyRowCommentFormDataDto } from "../../../_models";
import { useSelector } from "react-redux";
import { authorizationService } from "../../../_services";
import { utilFunctions } from "../../../_helpers";

const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
    },
}))(Tooltip);

const StudyBrowserList: React.FC<{
    data: StudyDto[];
    page: number;
    rowsPerPage: number;
    isLoading: boolean;
    isWebview: boolean;
    isGsdCodeApplied: boolean;
    isCommentingRow: number;
    rowComment: StudyRowCommentFormDataDto;
    onStudyDetailView: (studyId: number, studyTypeId: number) => void;
    onPotentialReportView: (studyId: number) => void;
    onProductionReportView: (studyId: number) => void;
    onYamazumiEbReportView: (studyId: number) => void;
    onYamazumiNebReportView: (studyId: number) => void;
    onTimeStudyReportView: (studyId: number) => void;
    onAdditionalActivityView: (studyId: number, studyTypeId: number) => void;
    onVideoView: (url: string) => void;
    onReportExport: (studyId: number) => void;
    onSelectBestCt: (studyId: string) => void;
    onRowCommentChange: (value: string) => void;
    onToggleAddComment: (rowId: number, data?: string,) => void;
    onApplyComment: (isBestVideo: boolean, studyOperationTimeId?: number) => void;
    onIsCommentingRowChange: (rowId: number | null) => void;
}> = (props) => {
    const onAddStudyOperationCommentState = useSelector((state: any) => state.studyBrowser.onAddStudyOperationComment)


    const onReportView = (studyId: number, studyType: number, isElementBased: boolean) => {
        if (studyType === APP_STUDIES.PROTENTIAL) {
            props.onPotentialReportView(studyId)
        }
        if (studyType === APP_STUDIES.YAMAZUMI && isElementBased === true) {
            props.onYamazumiEbReportView(studyId)
        }
        if (studyType === APP_STUDIES.YAMAZUMI && isElementBased === false) {
            props.onYamazumiNebReportView(studyId)
        }
        if (studyType === APP_STUDIES.PRODUCTION) {
            props.onProductionReportView(studyId)
        }
        if (studyType === APP_STUDIES.WORK_COMBINATION_AND_TIME_STUDY) {
            props.onTimeStudyReportView(studyId)
        }
    }

    return (
        <TableContainer>
            <Table size="small" stickyHeader aria-label="sticky table" className={'appTable'}>
                <TableHead>
                    <TableRow>
                        <TableCell>Study No</TableCell>
                        <TableCell>Factory</TableCell>
                        <TableCell>Study</TableCell>
                        <TableCell>Module</TableCell>
                        <TableCell>Shift</TableCell>
                        <TableCell>Style</TableCell>
                        <TableCell>Version</TableCell>
                        {!props.isWebview && <TableCell>IE</TableCell>}
                        <TableCell>Best CT</TableCell>
                        {props.isGsdCodeApplied && (
                            <TableCell>Performance</TableCell>
                        )}
                        <TableCell>Date</TableCell>
                        <TableCell style={{ maxWidth: "150px" }}>Detail</TableCell>
                        <TableCell style={{ maxWidth: "150px" }}>Report</TableCell>
                        <TableCell>Download</TableCell>
                        {props.isGsdCodeApplied && (
                            <TableCell align="center">Select Best CT</TableCell>
                        )}
                        {props.isGsdCodeApplied && (
                            <TableCell>Comment</TableCell>
                        )}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.isLoading ? <TableRow><TableCell colSpan={props.isWebview ? props.isGsdCodeApplied ? 15 : 11 : props.isGsdCodeApplied ? 16 : 12}> <CircularProgress size={20} /> Loading ...</TableCell></TableRow> : null}
                    {props.data.slice(props.page * props.rowsPerPage, props.page * props.rowsPerPage + props.rowsPerPage).map((row) => {
                        return (
                            <TableRow key={row.studyId}>
                                <TableCell>{utilFunctions.getStudyNo(row.factoryCode, row.studyName, row.studyNo || 0)}</TableCell>
                                <TableCell>{row.factoryName}</TableCell>
                                <TableCell>{row.studyName}</TableCell>
                                <TableCell>{row.module}</TableCell>
                                <TableCell>{row.shiftCode}</TableCell>
                                <TableCell>{row.style}</TableCell>
                                <TableCell>{row.version}</TableCell>
                                {!props.isWebview && <TableCell>{row.createdBy}</TableCell>}
                                <TableCell>{row.bestCT}</TableCell>
                                {props.isGsdCodeApplied && (
                                    <TableCell>{row.performance}</TableCell>
                                )}
                                <TableCell>{formatDateTime(row.createdAt)}</TableCell>
                                <TableCell>
                                    <a className={'textPrimary mrM'} onClick={() => props.onStudyDetailView(row.studyId, row.studyTypeId)}>
                                        <AssessmentIcon className="vAlignMiddle" />Detail
                                    </a>
                                    <a className={'textPrimary'} onClick={() => props.onAdditionalActivityView(row.studyId, row.studyTypeId)}>
                                        <AssessmentIcon className="vAlignMiddle" />AAT
                                    </a>
                                </TableCell>
                                <TableCell>
                                    <a className={'textPrimary'} onClick={() => onReportView(row.studyId, row.studyTypeId, row.isElementBased)}>
                                        <AssessmentIcon className="vAlignMiddle" />Report
                                    </a>
                                </TableCell>
                                <TableCell>
                                    {!!row.videoUrl && !props.isWebview &&
                                        <a className={'textPrimary'} onClick={() => props.onVideoView(row.videoUrl)}>
                                            <VideocamIcon className="vAlignMiddle" />Video
                                        </a>
                                    }
                                    {row.studyTypeId === APP_STUDIES.WORK_COMBINATION_AND_TIME_STUDY &&
                                        <a className={'textPrimary'} onClick={() => props.onReportExport(row.studyId)}>
                                            <GetAppIcon className="vAlignMiddle" />Export
                                        </a>
                                    }
                                </TableCell>
                                {props.isGsdCodeApplied && authorizationService.getAuthorizedUser().isAdmin && (
                                    <TableCell align="center">
                                        <Radio
                                            value={`${row.studyId}`}
                                            color={"primary"}
                                            name='select-best-ct-radio'
                                            checked={row.isBestVideo}
                                            disabled={!props.isGsdCodeApplied}
                                            onChange={(event) => props.onSelectBestCt(event.target.value)}
                                            size="small"
                                        />
                                    </TableCell>
                                )}

                                {props.isGsdCodeApplied && authorizationService.getAuthorizedUser().isAdmin && (
                                    <TableCell align="right">
                                        {props.isCommentingRow !== row.studyId && (
                                            <React.Fragment>
                                                {row.comment ? (
                                                    <HtmlTooltip title={
                                                        <React.Fragment>
                                                            <Typography color="inherit">Comment:</Typography>
                                                            <em>"{row.comment}"</em>
                                                        </React.Fragment>
                                                    }>
                                                        <a className={'textPrimary'} onClick={() => props.onToggleAddComment(row.studyId, row.comment)}>
                                                            <CommentIcon className="vAlignMiddle" /> Vew/Edit Comment
                                                        </a>
                                                    </HtmlTooltip>

                                                ) : (
                                                    <a className={'textPrimary'} onClick={() => props.onToggleAddComment(row.studyId, row.comment)}>
                                                        <AddCommentIcon className="vAlignMiddle" /> Add Comment
                                                    </a>
                                                )}
                                            </React.Fragment>
                                        )}

                                        {props.isCommentingRow === row.studyId && (
                                            <React.Fragment>
                                                <TextField
                                                    placeholder="Type here..."
                                                    type="text"
                                                    multiline
                                                    value={props.rowComment.comment.value}
                                                    error={!!props.rowComment.comment.error}
                                                    onChange={(event) => props.onRowCommentChange(event.target.value)}
                                                    disabled={!props.isGsdCodeApplied}
                                                    style={{ verticalAlign: 'middle' }}
                                                />
                                                <span>
                                                    <Tooltip title="Save">
                                                        <IconButton
                                                            size="small"
                                                            disabled={onAddStudyOperationCommentState.isLoading}
                                                            onClick={() => props.onApplyComment(row.isBestVideo, row.studyOperationTimeId)}>
                                                            <CheckIcon
                                                                fontSize="small"
                                                                color="primary"

                                                            />
                                                        </IconButton>
                                                    </Tooltip>

                                                    <Tooltip title="Cancel">
                                                        <IconButton
                                                            size="small"
                                                            disabled={onAddStudyOperationCommentState.isLoading}
                                                            onClick={() => props.onIsCommentingRowChange(null)}>
                                                            <CloseIcon
                                                                fontSize="small"
                                                                color="error"

                                                            />
                                                        </IconButton>
                                                    </Tooltip>

                                                </span>
                                            </React.Fragment>
                                        )}
                                    </TableCell>
                                )}
                            </TableRow>
                        )
                    })}
                    {(!props.isLoading && props.data.length == 0) ? <TableRow><TableCell colSpan={props.isWebview ? props.isGsdCodeApplied ? 15 : 11 : props.isGsdCodeApplied ? 16 : 12}> No data found.</TableCell></TableRow> : null}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default StudyBrowserList;
